'use client';
import { BaseLinePause } from '@/app/components/icons/BaseLinePause';
import { BaseLinePlay } from '@/app/components/icons/BaseLinePlay';
import { useAudioPlay } from '@/app/hooks';
import type { AudioOption } from '@/app/types';
import { cn } from '@/app/utils';

const DEFAULT_IMAGE_OVERLAY_COLOR = 'rgba(0, 0, 0, 0.16)';

export const AudioDom = ({
  audio,
  className,
  playIconClassName = 'size-4',
  animation = true,
  imageOverlay,
}: {
  audio: AudioOption;
  className?: string;
  playIconClassName?: string;
  animation?: boolean;
  imageOverlay?: boolean | string;
}) => {
  const { isPlaying, handlePlayPause } = useAudioPlay({ url: audio.url || '', id: audio.id || '' });
  const overlayColor = typeof imageOverlay === 'string' ? imageOverlay : DEFAULT_IMAGE_OVERLAY_COLOR;

  const handleAudioClick = (e: React.MouseEvent) => {
    // 立即阻止所有事件传播
    e.stopPropagation();
    e.preventDefault();
    handlePlayPause();
  };

  return (
    <div
      className={cn(
        'relative h-11 w-11 flex-shrink-0 cursor-pointer overflow-hidden rounded-full border-[1px] border-system-white08',
        className,
      )}
      onClick={handleAudioClick}
    >
      <img
        src={audio.img}
        alt={audio.name}
        className={cn(
          'pointer-events-none absolute top-0 left-0 h-full w-full object-cover',
          isPlaying && animation ? 'animate-[spin_4s_linear_infinite]' : 'transition-transform duration-300',
        )}
      />
      {imageOverlay ? (
        <div className="pointer-events-none absolute inset-0 z-[1]" style={{ backgroundColor: overlayColor }} />
      ) : null}
      {audio.url && (
        <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center text-white">
          {isPlaying ? <BaseLinePause className={playIconClassName} /> : <BaseLinePlay className={playIconClassName} />}
        </div>
      )}
    </div>
  );
};
